import { Typography } from '@mui/material';
import type { FC } from 'react';
import { useCallback } from 'react';
import type { ControllerRenderProps } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { OtherComments } from 'features/call/vrs-call-comments/enums';
import type {
  VrsCallCommentsAbuseForm,
  VrsCallCommentsAbuseFormControl,
} from 'features/call/vrs-call-comments/interfaces';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import { Checkbox, FormControlLabel } from 'features/ui/elements';

export const VrsCallCommentsHarassmentQuestions: FC<
  VrsCallCommentsAbuseFormControl
> = ({ control }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'abuseCommentText',
  });
  const { t: reasonTranslate } = useTranslation('translation', {
    keyPrefix: 'abuseCommentText.reason',
  });
  const onChangeCheckbox = useCallback(
    (
      field: ControllerRenderProps<
        VrsCallCommentsAbuseForm,
        'harassmentQuestions'
      >,
      checkedValue: string
    ) => {
      const currentValues = field.value || [];
      const currentValuesList = new Set(currentValues);
      if (currentValuesList.has(checkedValue)) {
        currentValuesList.delete(checkedValue);
      } else {
        currentValuesList.add(checkedValue);
      }
      field.onChange([...currentValuesList]);
    },
    []
  );

  return (
    <>
      <Typography variant='subtitle2' color={theme.palette.grey[300]} mt={12}>
        {t('other')}
      </Typography>

      <Controller
        name='harassmentQuestions'
        control={control}
        render={({ field }) => (
          <CheckboxGroup>
            {Object.values(OtherComments).map((comment) => (
              <CheckboxControlLabel
                value={comment}
                title={`label-${comment}`}
                label={reasonTranslate(comment)}
                control={<Checkbox title={comment} />}
                key={comment}
                onChange={(event) =>
                  onChangeCheckbox(
                    field,
                    (event.target as HTMLInputElement).value
                  )
                }
              />
            ))}
          </CheckboxGroup>
        )}
      />
    </>
  );
};

const CheckboxControlLabel = styled(FormControlLabel)`
  margin-top: ${theme.spacing(4)};
`;

const CheckboxGroup = styled('div')`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;
